import { memo, useRef } from "react";
import { DivItem } from "~/components/blocks/common/carousel/style";
import { ItemPackage } from "~/components/blocks/common/item-package";
import type { ItemPackageProps } from "~/components/blocks/common/item-package/type";

type CarouselItemProps = {
  displayItemCount: number;
  itemWidthCalc: number;
  isRankingType: boolean;
  className: string;
  isFirstLeftMargin: boolean;
} & Omit<ItemPackageProps, "ref">;

export const CarouselItem = memo((props: CarouselItemProps) => {
  const {
    displayItemCount,
    itemWidthCalc,
    isRankingType,
    className,
    shouldShowPreviewModal,
    isFirstLeftMargin,
    ...itemProps
  } = props;

  const ref = useRef<HTMLDivElement>(null);

  return (
    <DivItem
      ref={ref}
      displayItemCount={displayItemCount}
      itemWidthCalc={itemWidthCalc}
      isRankingType={isRankingType}
      className={className}
      isFirstLeftMargin={isFirstLeftMargin}
    >
      <ItemPackage {...itemProps} shouldShowPreviewModal={shouldShowPreviewModal} />
    </DivItem>
  );
});

CarouselItem.displayName = "CarouselItem";
